/** CSS contract: css-library/components/02-containers/tile-grid.css. */
import type { ComponentProps, Ref } from 'react';
import { ButtonControl } from './ButtonControl';

import type { ButtonHTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export type TileGridProps = ComponentProps<'div'>;

export function TileGrid({ className, ...props }: TileGridProps) {
  return <div className={cx('tile-grid', className)} {...props} />;
}

export type TileProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function Tile(
  { ref, className, type = 'button', children, ...rest }: TileProps & { ref?: Ref<HTMLButtonElement> },
) {
  return (
    <ButtonControl ref={ref} type={type} className={cx('tile', className)} {...rest}>
      {children}
    </ButtonControl>
  );
}
